export const count = (source, predicate) => {
    if (predicate) {
        return count2(source, predicate);
    }
    else {
        return count1(source);
    }
};
const count1 = async (source) => {
    let total = 0;
    for await (const _ of source) {
        total++;
    }
    return total;
};
const count2 = async (source, predicate) => {
    let total = 0;
    for await (const value of source) {
        if (predicate(value) === true) {
            total++;
        }
    }
    return total;
};
